var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('span',[_vm._v("La page que vous avez demandé n'existe pas ")]),_c('router-link',{staticClass:"mt-3",attrs:{"to":'/'}},[_vm._v(" -> Retourner sur le site ")])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h1',[_c('b',[_vm._v("404 :(")])])
}]

export { render, staticRenderFns }